import { Center, Icon, Image } from '@hover/blueprint';
import { iconImages } from '@hover/icons';
import React from 'react';

import { warn } from '../../helpers/logging';
import { useHomeownerTranslate } from '../../hooks';
import { usePartner } from '../../hooks/usePartner';
import { getPartnerProductConfiguration } from '../Customize/partners';

import type { PaletteCardProps } from './PaletteCard';
import { PaletteCard } from './PaletteCard';
import type { DefaultThumbnailRegion } from './constants/thumbnails';
import { DEFAULT_MATERIAL_PALETTE_THUMNBAILS } from './constants/thumbnails';

export interface MaterialPaletteCardProps extends PaletteCardProps {
  region: DefaultThumbnailRegion;
}

const MaterialPaletteCard = ({
  region,
  ...props
}: MaterialPaletteCardProps) => {
  const t = useHomeownerTranslate();

  const { name, isLoading } = props;

  const { partner } = usePartner();
  const partnerThumbnails = getPartnerProductConfiguration(
    {
      type: 'material',
      region,
    },
    partner,
  )?.paletteThumbnails;

  const regionThumbnails =
    partnerThumbnails ??
    (DEFAULT_MATERIAL_PALETTE_THUMNBAILS[region] as Record<
      string,
      string | undefined
    >);

  const thumbnail = regionThumbnails[name];
  const isMissingThumbnail = !thumbnail && !isLoading;

  if (isMissingThumbnail) {
    warn(
      `MaterialPaletteCard: No palette thumbnail found for ${region} / ${name}`,
    );
  }

  return (
    <PaletteCard {...props}>
      {isMissingThumbnail ? (
        <Center bg="neutral.50" height="100%" width="100%">
          <Icon color="neutral.200" icon={iconImages} size="large" />
        </Center>
      ) : (
        <Image
          alt={t('palette.materialAlt', { name })}
          height="100%"
          src={thumbnail}
          width="100%"
        />
      )}
    </PaletteCard>
  );
};

export { MaterialPaletteCard };
